import { useState } from "react";
import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import { PngIcon } from "../../common/PngIcon";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
  MenuContainer,
} from "./styles";
import scrollTo from "../../common/utils/scrollIntoView";
import { contactFormLink } from "../../common/constants";

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    const scrollIntoView = (id: string) => {
      scrollTo(id);
      setVisibility(false);
    };
    return (
      <>
        <CustomNavLinkSmall onClick={() => scrollIntoView("reviews")}>
          <Span>{t("Reviews")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollIntoView("feedback")}>
          <Span>{t("PrivateFeedback")}</Span>
        </CustomNavLinkSmall>
         <CustomNavLinkSmall onClick={() => scrollIntoView("focus")}>
          <Span>{t("Focus")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollIntoView("videos")}>
          <Span>{t("Videos")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollIntoView("about")}>
          <Span>{t("About")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall
          style={{ width: "180px" }}
          onClick={() => window.open(contactFormLink, "_blank")}
        >
          <Span>
            <Button>{t("Contact")}</Button>
          </Span>
        </CustomNavLinkSmall>
      </>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <PngIcon src="logo-full.png" width="140px" height="auto" />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <MenuContainer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>{t("Menu")}</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItem />
        </MenuContainer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
